

export function injectFileHtmlInput( input: HTMLInputElement, ...files: File[] ): void {
    const dataTransfer = new DataTransfer();
    files.forEach(file => dataTransfer.items.add(file));
    input.files = dataTransfer.files;
}
